
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PageHeader } from 'src/app/utils/models/page-header';
import { ForgotPwd } from '../../models/forgotpwd';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { ForgotpwdService } from '../../services/forgotpwd.service'; 
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ReturnStatement } from '@angular/compiler';
import { AlertPromise } from 'selenium-webdriver';

@Component({
  selector: 'app-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.css']
})
export class PasswordresetComponent {
  public resetPassword = false;
  @Output() closeChangePassword = new EventEmitter<null>();
  entities: Array<ForgotPwd>;
  headerEntity: PageHeader;
  entity: ForgotPwd = new ForgotPwd();
  disableSave: boolean = true;
  valid = 0;

  constructor(
    private _coreSaveService: CoreSaveService,
    private _notification: NotificationsService,
    private _forgotpwdService: ForgotpwdService,
  ) {
    this.headerEntity = this.initPageHeader();
    this.entities = [];
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.entity.UserName = user.UserName;
  }

  initPageHeader(): PageHeader {
    let headerEntity = new PageHeader();
    headerEntity.IconClass = "bi bi-emoji-frown";
    return headerEntity;
  }

  checkValidPassword(): boolean {
    this.valid = 0;
    var letter = /[a-z]/;
    var letterUp = /[A-Z]/;
    var number = /[0-9]/;
    var special = /[!"£$%^&*()-_=+]/;
    const NewPassword = this.entity.NewPassword;

    if (NewPassword.length < 6 || !letter.test(NewPassword) || !letterUp.test(NewPassword) || !number.test(NewPassword)) {
      if (NewPassword.length < 6) {
        this._notification.showWarning("Please make sure password is longer than 6 characters.");
        this.valid++;
        return false;
      }
      else if (!letter.test(NewPassword) || !letterUp.test(NewPassword)) {
        this._notification.showWarning("Please make sure Password Includes an UpperCase and LowerCase character");
        this.valid++;
        return false;
      }
      else if (!special.test(NewPassword)) {
        this._notification.showWarning("Please make sure that password includes special character");
        return false;
      }
      else if (!number.test(NewPassword)) {
        this._notification.showWarning("Please make sure Password Includes a Digit");
        this.valid++;
        return false;
      }
 }
   return true;
  }
  clear() {
    this.entity = new ForgotPwd();
  }

  save(event: any): void {
    if (this.entity.OldPassword === "" || this.entity.OldPassword === undefined) {
      this._notification.showWarning('Please enter old password');
      return;
    }
    if (this.entity.NewPassword === "" || this.entity.NewPassword === undefined) {
      this._notification.showWarning('Please enter new password');
      return;
    }
    if (this.entity.ConfirmPassword === "" || this.entity.ConfirmPassword === undefined) {
      this._notification.showWarning('Please enter confirm password');
      return;
    }

    if (this.entity.OldPassword != undefined) {
      this._forgotpwdService.checkCurrentPassword(this.entity.UserName, this.entity.OldPassword).subscribe((Response: APIResponse) => {
        if (Response.Success === false) {
          this._notification.showWarning('Old password is incorrect');
          return;
        }
        else if (this.entity.NewPassword != this.entity.ConfirmPassword) {
          this._notification.showWarning('Password and confirm password must be same');
          return;
        }
        else {
          this._forgotpwdService.saveNewPassword(this.entity.UserName, this.entity.NewPassword).subscribe((Response: APIResponse) => {
            if (Response.Success === true) {
              this._notification.showSuccess('Password changed Successfully');
              this.closeChangePassword.emit();
              this.resetPassword = true;
              this.clear();
            }
          });
        }
      });
    }
  }
}








